import React from "react";
import { Navigate } from "react-router-dom";
import { Crown, Sparkles } from "lucide-react";
import { useFlags } from "@/lib/useFlags";

/**
 * Wraps a page. If the flag is hidden entirely, redirect to /.
 * If the flag is premium, render the children behind a "Premium" veil.
 */
export default function FlagGuard({ flag, children }) {
  const { byKey, isVisible, isPremium } = useFlags();
  if (byKey && Object.keys(byKey).length > 0 && !isVisible(flag)) {
    return <Navigate to="/" replace />;
  }
  if (isPremium(flag)) {
    return (
      <div className="relative" data-testid="premium-veil">
        <div className="pointer-events-none opacity-60 blur-[1px]">
          {children}
        </div>
        <div className="absolute inset-0 grid place-items-center pt-24">
          <div className="totem-card p-6 max-w-sm mx-4 text-center border-totem-gold/40" style={{ boxShadow: "0 0 24px rgba(227,195,43,0.15)" }} data-testid="premium-veil-card">
            <div className="grid place-items-center w-14 h-14 rounded-full bg-totem-gold text-totem-bg mx-auto mb-3">
              <Crown size={22} />
            </div>
            <div className="mono uppercase text-[10px] tracking-widest text-totem-gold">
              Totem Pro
            </div>
            <h2 className="display-heading text-xl mt-1">Premium feature</h2>
            <p className="text-sm text-totem-textDim mt-3 leading-relaxed">
              This feature is being finalised as part of the Totem Pro tier. It&apos;ll unlock once
              the tier ships.
            </p>
            <div className="mt-4 mono text-[11px] uppercase text-totem-textFaint flex items-center justify-center gap-1">
              <Sparkles size={11} /> Coming soon
            </div>
          </div>
        </div>
      </div>
    );
  }
  return children;
}
